import React from 'react';
import Button from '../Button';
import { TimesIcon } from '../Icons';
import { useTranslation } from 'react-i18next';
import { saveToStore } from 'utils/storeHelpers';
import { openExtensionUrl } from 'utils/urlHelpers';

const ReminderExtModal = ({ onClose, className }) => {
  const { t } = useTranslation();

  const handleConfirmClick = () => {
    openExtensionUrl();
    onClose();
  };

  const onCancel = () => {
    saveToStore('extension_reminder', true);
    onClose();
  };

  return (
    <div className={`reminder-modal mx-4 d-flex flex-column justify-content-between px-10 py-15 ${className}`}>
      <button className='btn p-0 modal-close' onClick={onClose}>
        <TimesIcon />
      </button>
      <h2 className='mb-8'>{t('get_extension_title')}</h2>
      <p className='mb-12'>{t('get_extension_desc')}</p>
      <div className='d-flex align-items-center'>
        <Button type='button' className={'btn-sm mr-12 bg-white border-primary text-primary'} onClick={onCancel}>
          {t('btn_dont_show_again')}
        </Button>
        <Button type='button' onClick={handleConfirmClick} className={'btn-sm px-md-10 btn-primary'}>
          {t('btn_get_ext')}
        </Button>
      </div>
    </div>
  );
};

export default ReminderExtModal;
